module.exports = __webpack_public_path__ + "static/media/new-chat.67ef4034.svg";